/// <amd-module name="Repos/VersionDropdown/Components/VersionDropdownFilterBarItem" />
import * as React from "react";
import { refToBranchName } from "Repos/Common/Util/Ref";
import { gitVersionStringToVersionDescriptor } from "Repos/Common/Util/Version";
import { FilterBarItem, IFilterBarItemProps, IFilterBarItemState } from "VSSUI/FilterBarItem";
import { IListBoxItem } from "VSSUI/ListBox";
import { VersionDropdown, VersionDropdownExpandableTextField } from "./VersionDropdown";
import { IVersionDropdownItem, IVersionDropdownProps } from "./VersionDropdown.Props";

export interface IVersionDropdownFilterBarItemProps extends IFilterBarItemProps, Pick<IVersionDropdownProps, "placeholder"> {
    initiallySelectedItem: string | undefined;
}

export class VersionDropdownFilterBarItem extends FilterBarItem<IListBoxItem<string>, IVersionDropdownFilterBarItemProps, IFilterBarItemState<any>> {
    private dropdown = React.createRef<VersionDropdown>();

    public render() {
        return (
            <VersionDropdown
                ref={this.dropdown}
                onSelect={this.onSelectBranch}
                placeholder={this.props.placeholder}
                initiallySelectedVersion={
                    this.props.initiallySelectedItem
                        ? gitVersionStringToVersionDescriptor(`GB${refToBranchName(this.props.initiallySelectedItem)}`)
                        : undefined
                }
                providerOptions={{
                    viewClearButton: true,
                    viewTagsPivot: false
                }}
                renderExpandable={expandableProps => (
                    <VersionDropdownExpandableTextField {...expandableProps} className="repos-version-dropdown-filterbaritem flex-row flex-grow" />
                )}
            />
        );
    }

    public focus() {
        if (this.dropdown.current) {
            this.dropdown.current.focus();
        }
    }

    private onSelectBranch = (event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<IVersionDropdownItem>) => {
        this.setFilterValue({ value: item ? item.text : null });
    };
}
